import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/react';
import { customFilterDropdown } from 'src/domains/casino/webview/CasinoGames/filters-dropdown/CustomFilterDropdown.style';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { withConfig } from 'src/withConfig';
import Select from 'react-select';
import { CloseIcon } from 'src/ui/assets/icons/other/CloseIcon';

interface SearchAndFilterWrapperType {
    isDropdownOpened?: boolean;
    isMiniGamesListDisplayed: boolean;
}

export const SearchAndFilterWrapper = withConfig(theme => styled('div', { label: 'SearchAndFilterWrapper' }) <SearchAndFilterWrapperType>`
    align-items: start;
    display: flex;
    gap: ${theme.star.gap.large};
    justify-content: start;
    overflow: hidden;
    padding: 16px 0 16px 16px;
    position: sticky;
    top: 48px;
    z-index: ${({ isMiniGamesListDisplayed }): number => isMiniGamesListDisplayed ? theme.star.zIndexGlobal.base : theme.star.zIndexGlobal.above};
    ${({ isDropdownOpened }): string => isDropdownOpened === true ? 'margin-bottom: -198px;' : ''}
    &::before {
        content: '';
        height: 76px;
        background: ${theme.star.casino.bgColor};
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    @media ${theme.star.mediaQuery.desktop} {
        top: 0;
        padding-left: 24px;
    }
`);

interface SearchInputWrapperPropsType {
    isSearchOpen: boolean;
}

export const SearchInputWrapper = withConfig(theme => styled('div', { label: 'SearchInputWrapper' })<SearchInputWrapperPropsType>`
    height: 44px;
    left: 72px;
    overflow: hidden;
    pointer-events: ${({ isSearchOpen }): string => isSearchOpen ? 'auto' : 'none'};
    position: absolute;
    right: 16px;
    @media ${theme.star.mediaQuery.desktop} {
        right: 24px;
    }
`);

interface SearchInputBoxPropsType {
    isSearchOpen: boolean;
}

export const SearchInputBox = styled('div', { label: 'SearchInputBox' })<SearchInputBoxPropsType>`
    height: 44px;
    opacity: ${({ isSearchOpen }): string => isSearchOpen ? '1': '0'};
    position: absolute;
    right: 100%;
    transform: ${({ isSearchOpen }): string => isSearchOpen ? 'translateX(100%)': 'translateX(0)'};
    transition: opacity .3s ease, transform 0.2s ease;
    width: 100%;
`;

export const SearchInput = withConfig(theme => styled('input', { label: 'SearchInput' })`
    background: ${theme.star.searchBar.bgColorTertiary};
    border-radius: ${theme.star.searchBar.searchBarCasino.radius};
    border: solid 1px transparent;
    color: ${theme.star.searchBar.searchBarCasino.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    height: 100%;
    line-height: 1.4286;
    padding: 12px 44px 12px 12px;
    width: 100%;
    &:focus {
        border-color: ${theme.star.searchBar.searchBarCasino.borderColor};
    }
    &::-webkit-search-cancel-button {
        display: none;
    }
`);

export const SearchCloseButton = withConfig(theme => styled(CloseIcon, { label: 'SearchCloseButton' })`
    cursor: pointer;
    color: ${theme.star.searchBar.searchBarCasino.txtColor};
    inset: 0 4px 0 0;
    margin: auto 0 auto auto;
    padding: 8px;
    position: absolute;
    width: 32px;
`);

interface CasinoFilterWrapperPropsType {
    isSearchOpen: boolean;
}

export const CasinoFilterWrapper = styled('div', { label: 'CasinoFilterWrapper' })<CasinoFilterWrapperPropsType>`
    opacity: ${({ isSearchOpen }): string => isSearchOpen ? '0' : '1'};
    overflow-x: hidden;
    padding: 6px 0 0;
    pointer-events: ${({ isSearchOpen }): string => isSearchOpen ? 'none' : 'auto'};
    transition: opacity .2s ease;
`;

interface FilterDropdownPropsType {
    isActive: boolean;
    filterVersion: FiltersSkinType;
}

export const FilterDropdown = withConfig(theme => styled(Select, { label: 'FilterDropdown' })<FilterDropdownPropsType>`
    /* External library custom drop down */
    ${({ isActive, filterVersion }): SerializedStyles => customFilterDropdown(theme, isActive, filterVersion)}
    border-radius: ${theme.star.filtersColors.radius};
    border-style: solid;
    border-width: 1px;
    height: 32px;
    margin: 0 auto 0 4px;
    position: fixed;
`);
